import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Dropdown } from 'cat-ecommerce-alloy';

const EquipmentRangeDropdown = ({
  modelsList,
  itemToString,
  getSerialRangeValue,
  selectedSerial,
  serialRangeErrors
}) => {
  const [t] = useTranslation();
  const serialRangeList = modelsList.map((item, index) => ({
    displayValue: `${item.salesModel} ${item.serialNumberOrPrefix.prefix} ${item.serialNumberOrPrefix.low} ${item.serialNumberOrPrefix.high}`,
    value: index
  }));

  return (
    <>
      <Dropdown
        items={serialRangeList}
        itemToString={itemToString}
        keyToString={({ value }) => value}
        onChange={getSerialRangeValue}
        placeholder={{
          displayValue: t('PM_KIT_MODEL1'),
          value: 'placeholder'
        }}
        selected={selectedSerial}
        className={serialRangeErrors ? 'dropdown-invalid' : ''}
      />
      {serialRangeErrors && <p className="error">{t('PM_KIT_SERVICE_ERR')}</p>}
    </>
  );
};

EquipmentRangeDropdown.propTypes = {
  serialRangeErrors: PropTypes.shape({ message: PropTypes.string }),
  itemToString: PropTypes.func,
  modelsList: PropTypes.arrayOf(
    PropTypes.shape({
      serialNumberOrPrefix: PropTypes.shape({
        prefix: PropTypes.string,
        high: PropTypes.string,
        low: PropTypes.string
      })
    })
  ),
  getSerialRangeValue: PropTypes.func,
  selectedSerial: PropTypes.shape({
    displayValue: PropTypes.string,
    value: PropTypes.number
  })
};

export default EquipmentRangeDropdown;
